import React, { useEffect, useState } from "react";
import { UserOutlined, KeyOutlined, DownOutlined, GlobalOutlined } from "@ant-design/icons";

import {
  AccountInput,
  Container,
  LeftBox,
  LoginBox,
  LoginContainer,
  LoginItem,
  PasswordInput,
  SubmitButton,
  Title,
  TitleBox,
  WelCome,
} from "./index.styled";
import { useAppDispatch, useAppSelector } from "@/store";
import { loginAction } from "@/store/action/loginAction";
import { Dropdown, Space, message } from "antd";
import type { MenuProps } from "antd";
import { useNavigate } from "react-router-dom";
import MyImage from "@/components/basic/MyImage";
import { setCookie } from "@/utils/cookies";
import { changeOpenKey } from "@/store/modules/globalConstans.slice";
import { useTranslation } from "react-i18next";
import i18n, {
  AppLanguage,
  LANG_STORAGE_KEY,
  languageLabelMap,
} from "@/utils/locales/i18n";

export default function Login() {
  const dispatch = useAppDispatch();
  const navigator = useNavigate();
  const { t } = useTranslation();
  const [langTitle, setLangTitle] = useState(
    languageLabelMap[(i18n.language as AppLanguage) || "en"] || "English"
  );

  // 当前侧边栏菜单展开情况
  useAppSelector((state) => state.globalConstans)

  /**
   * 监听侧边栏状态 根据上一次选中的侧边栏跳转对应的路由
   */
  const watchAsidMenuStatus = () => {
    navigator("/admin/dataCenter")
    dispatch(changeOpenKey(['/admin/dataCenter']))
  }

  // 设置时间
  let inFifteenMinutes = new Date(new Date().getTime() + 30 * 1000);
  const onFinish = (value: any) => {
    localStorage.setItem("userInfo", JSON.stringify(value));
    dispatch(loginAction(value)).then((res: any) => {
      localStorage.setItem("userInfoObject", JSON.stringify(res.payload.data));
      setCookie("userInfoObject", JSON.stringify(res.payload.data), {
        expires: inFifteenMinutes,
        path: "/",
      });
      if (res.payload.code === 1) {
        message.success(t("Login success"));
        watchAsidMenuStatus()
      } else {
        message.error(res.payload.error);
      }
    });
  };

  const changeAppLanguage = (lang: AppLanguage) => {
    localStorage.setItem(LANG_STORAGE_KEY, lang);
    i18n.changeLanguage(lang);
    setLangTitle(languageLabelMap[lang]);
  };

  const languageItems: MenuProps["items"] = [
    {
      key: "en",
      label: t("English"),
      onClick: () => changeAppLanguage("en"),
    },
    {
      key: "zh",
      label: t("Chinese"),
      onClick: () => changeAppLanguage("zh"),
    },
    {
      key: "vn",
      label: t("Vietnam"),
      onClick: () => changeAppLanguage("vn"),
    },
  ];

  useEffect(() => {
    if (localStorage.getItem("come-to-chant-token")) {
      navigator("/admin/dataCenter");
    }
  }, []);

  return (
    <Container>
      <div style={{ position: "absolute", top: 24, right: 32, zIndex: 10 }}>
        <Dropdown menu={{ items: languageItems }}>
          <a onClick={(e) => e.preventDefault()} style={{ color: "#886DFF" }}>
            <Space>
              <GlobalOutlined />
              <span>{t(langTitle)}</span>
              <DownOutlined />
            </Space>
          </a>
        </Dropdown>
      </div>
      <LoginBox>
        <LeftBox>
          <TitleBox>
            <MyImage
              width={150}
              height={70}
              src={require("@/assets/img/home/bet.png")}
            />
          </TitleBox>
          <Title style={{ marginTop: 10 ,textAlign: "left" , marginLeft: 20}}>{t("Manage System")}</Title>
        </LeftBox>
        <LoginContainer onFinish={onFinish} autoComplete="off">
          <WelCome style={{fontSize: 25}} >{t("Welcome")}</WelCome>
          <div style={{fontSize: 16}}>{t("Blind Box management System")}</div>
          <LoginItem>
            <LoginItem
              name="username"
              rules={[{ required: true, message: t("Please input your account") }]}
            >
              <AccountInput
                size="large"
                placeholder={t("Please input your account")}
                prefix={<UserOutlined />}
              />
            </LoginItem>
            <LoginItem
              name="password"
              rules={[{ required: true, message: t("password enter your password") }]}
            >
              <PasswordInput
                size="large"
                placeholder={t("password enter your password")}
                prefix={<KeyOutlined />}
              />
            </LoginItem>
            <LoginItem>
              <SubmitButton type="primary" htmlType="submit">
                {t("Login")}
              </SubmitButton>
            </LoginItem>
          </LoginItem>
        </LoginContainer>
      </LoginBox>
    </Container>
  );
}
